<template>

  <!-- 最新年度の実績 -->
  <div>

    <!-- 実績値エラー表示 -->
    <div class="l-contentsSection error" 
      v-if="$v.acquisitionRate.$invalid 
      || $v.acquisitionRate.regularTakeAnnualAcquisition.$invalid
      || $v.acquisitionRate.nonRegularTakeAnnualAcquisition.$invalid
      || $v.acquisitionRate.regularGetAnnualAcquisition.$invalid
      || $v.acquisitionRate.nonRegularGetAnnualAcquisition.$invalid
      || $v.acquisitionRate.resultMemo.$invalid 
      || $v.acquisitionRate.actionMemo.$invalid">
      <div v-if="$v.acquisitionRate.regularTakeAnnualAcquisition.$invalid" style="padding-bottom:5px;">
        <span style="color:red; font-size: 1.5rem;margin-left: 20px;">取得日数（正社員）　　：</span>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.acquisitionRate.regularTakeAnnualAcquisition.$invalid && !$v.acquisitionRate.regularTakeAnnualAcquisition.numeric" validation="numeric"/>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.acquisitionRate.regularTakeAnnualAcquisition.$invalid && $v.acquisitionRate.regularTakeAnnualAcquisition.numeric && !$v.acquisitionRate.regularTakeAnnualAcquisition.between" validation="between" valueMin="0" valueMax="99999999"/>
      </div>
      <div v-if="$v.acquisitionRate.nonRegularTakeAnnualAcquisition.$invalid" style="padding-bottom:5px;">
        <span style="color:red; font-size: 1.5rem;margin-left: 20px;">取得日数（非正規社員）：</span>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.acquisitionRate.nonRegularTakeAnnualAcquisition.$invalid && !$v.acquisitionRate.nonRegularTakeAnnualAcquisition.numeric" validation="numeric"/>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.acquisitionRate.nonRegularTakeAnnualAcquisition.$invalid && $v.acquisitionRate.nonRegularTakeAnnualAcquisition.numeric && !$v.acquisitionRate.nonRegularTakeAnnualAcquisition.between" validation="between" valueMin="0" valueMax="99999999"/>
      </div>
      <div v-if="$v.acquisitionRate.regularGetAnnualAcquisition.$invalid" style="padding-bottom:5px;">
        <span style="color:red; font-size: 1.5rem;margin-left: 20px;">付与日数（正社員）　　：</span>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.acquisitionRate.regularGetAnnualAcquisition.$invalid && !$v.acquisitionRate.regularGetAnnualAcquisition.numeric" validation="numeric"/>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.acquisitionRate.regularGetAnnualAcquisition.$invalid && $v.acquisitionRate.regularGetAnnualAcquisition.numeric && !$v.acquisitionRate.regularGetAnnualAcquisition.between" validation="between" valueMin="0" valueMax="99999999"/>
      </div>
      <div v-if="$v.acquisitionRate.nonRegularGetAnnualAcquisition.$invalid" style="padding-bottom:5px;">
        <span style="color:red; font-size: 1.5rem;margin-left: 20px;">付与日数（非正規社員）：</span>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.acquisitionRate.nonRegularGetAnnualAcquisition.$invalid && !$v.acquisitionRate.nonRegularGetAnnualAcquisition.numeric" validation="numeric"/>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.acquisitionRate.nonRegularGetAnnualAcquisition.$invalid && $v.acquisitionRate.nonRegularGetAnnualAcquisition.numeric && !$v.acquisitionRate.nonRegularGetAnnualAcquisition.between" validation="between" valueMin="0" valueMax="99999999"/>
      </div>
      <div v-if="$v.acquisitionRate.resultMemo.$invalid" style="padding-bottom:5px;">
        <span style="color:red; font-size: 1.5rem;margin-left: 20px;">実績に関するメモ：</span>
        <ValidationErrorMessage v-show="$v.acquisitionRate.resultMemo.$invalid && !$v.acquisitionRate.resultMemo.maxLength" validation="maxLength" valueLength="300" />
      </div>
      <div v-if="$v.acquisitionRate.actionMemo.$invalid" style="padding-bottom:5px;">
        <span style="color:red; font-size: 1.5rem;margin-left: 20px;">具体的なアクション：</span>
        <ValidationErrorMessage v-show="$v.acquisitionRate.actionMemo.$invalid && !$v.acquisitionRate.actionMemo.maxLength" validation="maxLength" valueLength="300" />
      </div>
    </div>

    <!-- 実績値入力 -->
    <div class="human-capitalt-data-wrap">
      <div class="human-capitalt-data-wrap__table01">
        <p class="l-formGroup__label u-mb10">有給</p>
        <table class="human-capitalt-data-table">
          <colgroup>
            <col style="width: 50px;">
            <col>
            <col>
          </colgroup>
          <thead>
            <tr>
              <th></th>
              <th>正社員</th>
              <th>非正規社員</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>取得日数</th>
              <td>
                <div class="human-capitalt-data-table__input is-extra-wide has-unit">
                  <TextBox v-model.trim="$v.acquisitionRate.$model.regularTakeAnnualAcquisition" type="text" name="acquisitionRate.regularTakeAnnualAcquisition" class="u-tac" @input="changeInput()"></TextBox>
                  <span class="human-capitalt-data-table__unit">日</span>
                </div>
              </td>
              <td>
                <div class="human-capitalt-data-table__input is-extra-wide has-unit">
                  <TextBox v-model.trim="$v.acquisitionRate.$model.nonRegularTakeAnnualAcquisition" type="text" name="acquisitionRate.nonRegularTakeAnnualAcquisition" class="u-tac" @input="changeInput()"></TextBox>
                  <span class="human-capitalt-data-table__unit">日</span>
                </div>
              </td>
            </tr>
            <tr>
              <th>付与日数</th>
              <td>
                <div class="human-capitalt-data-table__input is-extra-wide has-unit">
                  <TextBox v-model.trim="$v.acquisitionRate.$model.regularGetAnnualAcquisition" type="text" name="acquisitionRate.regularGetAnnualAcquisition" class="u-tac" @input="changeInput()"></TextBox>
                  <span class="human-capitalt-data-table__unit">日</span>
                </div>
              </td>
              <td>
                <div class="human-capitalt-data-table__input is-extra-wide has-unit">
                  <TextBox v-model.trim="$v.acquisitionRate.$model.nonRegularGetAnnualAcquisition" type="text" name="acquisitionRate.nonRegularGetAnnualAcquisition" class="u-tac" @input="changeInput()"></TextBox>
                  <span class="human-capitalt-data-table__unit">日</span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div><!--/human-capitalt-data-wrap__table01-->

      <div class="human-capitalt-data-wrap__arrow"></div>

      <div class="human-capitalt-data-wrap__results">
        <div class="human-capitalt-data-results ">
          <div class="human-capitalt-data-results__text is-flex">
            年次有給休暇取得率
            <p>
              <span>正社員</span>
              <strong v-if="this.calcAchievementRegularAnnualAcquisitionRate!=null">{{this.calcAchievementRegularAnnualAcquisitionRate}}</strong>
              <strong v-else>---</strong>%</p>
            <p><span>非正規社員</span>
              <strong v-if="this.calcAchievementNonRegularAnnualAcquisitionRate!=null">{{this.calcAchievementNonRegularAnnualAcquisitionRate}}</strong>
              <strong v-else>---</strong>%</p>
          </div>
        </div>
      </div>

    </div><!--/human-capitalt-data-wrap-->
    <div class="l-contentsGrid2 u-mt30">
      <div class="l-contentsGrid2__item">
        <div>
          <div class="l-formGroup">
            <label class="l-formGroup__label u-mb10">実績に関するメモ</label>
            <p v-if="this.num==0" class="l-memo-note">現状の課題や、課題に対してのアドバイスをメモしましょう。</p>
              <TextArea class="l-formGroup__textArea is-highMiddle" v-model="acquisitionRate.resultMemo" @input="changeInput()" ></TextArea>
          </div>
        </div>
      </div>
      <div class="l-contentsGrid2__item">
        <div class="l-contentsMemo" ref="memoEdit">
          <div class="l-formGroup">
            <div class="l-contentsMemo__title">
              <label class="l-formGroup__label">具体的なアクション</label>
              <button class="link-arrow is-normal js-memo-edit" @click="editMode()">編集する</button>
              <button class="link-arrow is-edit js-memo-exit" @click="editMode()">編集を終わる</button>
            </div>
            <p v-if="this.num==0" class="l-memo-note">今後どういった取り組みをしていくかをメモしましょう。<br>レポート画面からも入力できます。</p>
            <div class="l-contentsMemo__body">
              <div class="l-grayBox is-normal" style="min-height:108px;">
                <div>
                  <p  class="l-text" style="white-space: pre-line;" v-html="repalceLink(acquisitionRate.actionMemo)"></p>
                </div>
              </div>
            </div>
            <TextArea class="l-formGroup__textArea is-highMiddle is-edit" v-model="acquisitionRate.actionMemo" @input="changeInput()"></TextArea>
          </div>
        </div>
      </div>
    </div><!--/l-contentsGrid2-->
  </div>
</template>

<script>
import TextBox from '@/components/parts/form/TextBox.vue';
import ValidationErrorMessage from '@/components/parts/form/ValidationErrorMessage.vue';
import TextArea from '@/components/parts/form/TextArea.vue';
import { numeric, between, maxLength } from 'vuelidate/lib/validators';
//import Currency from '@/components/parts/human_capital/parts/Currency.vue';

export default {
  components: {
    TextBox,
    ValidationErrorMessage,
    TextArea,
//    Currency,
  },
  props: {
    // 表示年度の年次有給休暇取得率データ
    acquisitionRate: {},
    num: null,
  },
  data() {
    return {
      isAnswerChanged:false,
      unit1: "名",
      unit2: "％",
    }
  },
  computed: {
    calcAchievementRegularAnnualAcquisitionRate() {
      if ( !(this.acquisitionRate.regularTakeAnnualAcquisition!=null && this.acquisitionRate.regularGetAnnualAcquisition!=null) ) {
        return null;
      }else if ( String(this.acquisitionRate.regularTakeAnnualAcquisition).length * String(this.acquisitionRate.regularGetAnnualAcquisition).length == 0 ) {
        return null;
      }else if ( isNaN(this.acquisitionRate.regularTakeAnnualAcquisition) || isNaN(this.acquisitionRate.regularGetAnnualAcquisition)) {
        return null;
      }else{
        if ( this.acquisitionRate.regularTakeAnnualAcquisition != null && this.acquisitionRate.regularGetAnnualAcquisition != null ){
          if(this.acquisitionRate.regularGetAnnualAcquisition == 0) return null;
          if(this.acquisitionRate.regularTakeAnnualAcquisition == 0) return 0;
          let val = (this.acquisitionRate.regularTakeAnnualAcquisition / this.acquisitionRate.regularGetAnnualAcquisition) * 100 * 10; // 小数点以下１まで表示なので10
          return Math.round(val)/10;
        }else{
          return null;
        }
      }
    },
    calcAchievementNonRegularAnnualAcquisitionRate() {
      if ( !(this.acquisitionRate.nonRegularTakeAnnualAcquisition!=null && this.acquisitionRate.nonRegularGetAnnualAcquisition!=null) ) {
        return null;
      }else if ( this.acquisitionRate.nonRegularTakeAnnualAcquisition=='' || this.acquisitionRate.nonRegularGetAnnualAcquisition=='') {
        return null;
      }else if ( isNaN(this.acquisitionRate.nonRegularTakeAnnualAcquisition) || isNaN(this.acquisitionRate.nonRegularGetAnnualAcquisition)) {
        return null;
      }else{
        if ( this.acquisitionRate.nonRegularTakeAnnualAcquisition != null && this.acquisitionRate.nonRegularGetAnnualAcquisition != null ){
          if(this.acquisitionRate.nonRegularGetAnnualAcquisition == 0) return null;
          if(this.acquisitionRate.nonRegularTakeAnnualAcquisition == 0) return 0;
          let val = (this.acquisitionRate.nonRegularTakeAnnualAcquisition / this.acquisitionRate.nonRegularGetAnnualAcquisition) * 100 * 10; // 小数点以下１まで表示なので10
          return Math.round(val)/10;
        }else{
          return null;
        }
      }
    },
  },
  validations: {
    acquisitionRate: {
      regularTakeAnnualAcquisition : { numeric, between: between(0,99999999) },     // 取得日数（正社員）
      regularGetAnnualAcquisition : { numeric, between: between(0,99999999) },      // 付与日数（正社員）
      nonRegularTakeAnnualAcquisition : { numeric, between: between(0,99999999) },  // 取得日数（非正規社員）
      nonRegularGetAnnualAcquisition : { numeric, between: between(0,99999999) },   // 付与日数（非正規社員）
      resultMemo: { maxLength: maxLength(300) }, // 実績メモ
      actionMemo: { maxLength: maxLength(300) }, // アクションメモ
    }
  },
  watch: {
    acquisitionRate() {
      this.inputAcquisitionRate();
    }
  },
  created: function () {

  },
  mounted() {

  },
  methods: {
    inputAcquisitionRate() {
      this.$emit("change-acquisition-rate", {
        acquisitionRate: this.acquisitionRate,
        num: this.num,
      });
    },
    // アクションメモの編集モード切替
    editMode(isEdit){
      const memoElm = this.$refs.memoEdit
      if ( isEdit == null || memoElm.classList.contains("is-edit") ){
        memoElm.classList.toggle("is-edit");
      }
    },
    // 文字列中のURLをaタグに変換する
    repalceLink(text) {
      return text ? text.replace(/(https?:\/\/[^\s]*)/g, "<a href='$1'style='text-decoration: underline; color: #0070be;' target='_blank' rel='noopener noreferrer'>$1</a>") : '';
    },
    // 編集フラグの取得（メイン画面の画面遷移時に呼び出されてチェックする）
    getIsAnswerChanged(){
      return this.isAnswerChanged; 
    },
    // 入力データ編集フラグ
    changeInput(){
      this.isAnswerChanged = true
    },
    setIsAnswerChanged(flag){
      this.isAnswerChanged = flag;
    }
  }
}

</script>
